import React from "react";
import { Link } from "react-router-dom";
import { StatusErrorIcon, StatusOkIcon } from "affinityIcons";
import { styled } from "styled-components";

import { ConsentHistoryInfoText } from "./consentHistoryInfoText";

export const consentLabels = {
  service: {
    yes: "Patient consents to use Liberty service",
    no: (
      <>
        Patient <strong>does not</strong> consent to use Liberty service
      </>
    ),
  },
  privacyPolicy: {
    yes: (
      <>
        Patient consents to share data according to the{" "}
        <Link target="_blank" to="https://www.libertycareportal.co/privacy-policy">
          Privacy Policy
        </Link>
      </>
    ),
    no: (
      <>
        Patient <strong>does not</strong> consent to share data according to the{" "}
        <Link to="/support">Privacy Policy</Link>
      </>
    ),
  },
  feedback: {
    yes: "Patient consents to be contacted for feedback",
    no: (
      <>
        Patient <strong>does not</strong> consent to be contacted for feedback
      </>
    ),
  },
};
type ConsentTypeKeys = keyof typeof consentLabels;

const ConsentHistoryInfo = styled(ConsentHistoryInfoText)`
  margin-left: calc(1em + 0.5rem);

  &:not(:empty) {
    padding-top: 0.5rem;
  }
`;

export const PatientConsent: React.FC<{
  value: boolean;
  lastUpdated?: Maybe<{
    changeDate?: string;
    updatingNow?: boolean;
    changedBy?: Maybe<{ firstName: string; lastName: string }>;
  }>;
  consentType: ConsentTypeKeys;
}> = ({ value, consentType, lastUpdated }) => (
  <>
    {value ? <StatusOkIcon /> : <StatusErrorIcon />} {consentLabels[consentType][value ? "yes" : "no"]}
    {lastUpdated && <ConsentHistoryInfo lastUpdated={lastUpdated} />}
  </>
);
